import React, { useEffect, useState } from 'react';
import { useHistory, useNavigate } from 'react-router-dom';
import 'react-chat-widget/lib/styles.css';
import firebase from 'firebase';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import ChatMsgRendererAdmin from './ChatMsgRendererAdmin';

function ChatBot({
  setIsChatWidget = () => null,
  chatMessages,
  setChatMessages,
  currentStudent,
}) {
  // const [chatMessages, setChatMessages] = useState([]);
  const [message, setMessage] = useState('');
  const [currentUser, setCurrentUser] = useState({});
  const [typing, setTyping] = useState(false);
  const chatBoxRef = React.useRef();
  // const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    if (message.trim() === '') return; // Trim to avoid sending empty spaces

    handleNewUserMessage(message);

    // setChatMessages((prev = []) => {
    //   console.log(prev, 'lllll');
    //   return [{ sentBy: 'user', text: message, type: 'msg' }, ...prev];
    // });

    setMessage(''); // Clear the input after updating messages
  };

  const handleNewUserMessage = (newMessage) => {
    setTyping(true);
    db.collection('Chats2')
      .doc()
      .set({
        sentBy: 'admin',
        userID: currentStudent,
        text: newMessage,
        id: new Date().getTime().toString(),
        email: currentUser.email,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        user: {
          _id: currentUser.uid,
          id: currentUser.uid,
          name: currentUser.email,
        },
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setTyping(false);
        console.log('Finally');
      });
    document.getElementById('messageOut').play();
  };

  const getUsers = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setCurrentUser(user);
      }
    });
  };

  useEffect(() => {
    getUsers();
  }, []);

  const scrollToBottom = () => {
    console.log('chatBoxRef.curren', chatBoxRef.current);
    chatBoxRef.current.scrollTo({
      left: 0,
      top: chatBoxRef.current.clientHeight,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatMessages]);

  return (
    <div
      class='chatBotWidget_Conversation'
      /*       style={{ height: "88vh" }} */
      aria-live='polite'
    >
      <div class='chatBotWidget-header'>
        {/* <h4 class='rcw-title'>Welcome to TN College</h4> */}
        <span></span>
      </div>
      <div
        class='chatBotWidget-msg_Container'
        // style={{ height: '56vh', maxHeight: '56vh' }}
        ref={chatBoxRef}
      >
        {chatMessages?.length > 0 &&
          chatMessages.map((item, i) => {
            return <ChatMsgRendererAdmin key={i} item={item} />;
          })}
      </div>
      <form class='chatBotWidget-sender' onSubmit={onSubmit}>
        <input
          type='text'
          class='chatBotWidget-new-message'
          name='message'
          placeholder='Type a message...'
          autocomplete='off'
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <button type='submit' style={{ background: '#f4f7f9', border: 0 }}>
          <img
            src='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgNTM1LjUgNTM1LjUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUzNS41IDUzNS41OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPGcgaWQ9InNlbmQiPgoJCTxwb2x5Z29uIHBvaW50cz0iMCw0OTcuMjUgNTM1LjUsMjY3Ljc1IDAsMzguMjUgMCwyMTYuNzUgMzgyLjUsMjY3Ljc1IDAsMzE4Ljc1ICAgIiBmaWxsPSIjY2JjYmNiIi8+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='
            style={{ height: 25 }}
            alt='Send'
          />
        </button>
      </form>
    </div>
  );
}

export default ChatBot;
